import React, { FC, useEffect } from "react";
import { Form, Radio, Select, Row, Col } from "antd";

type PersonalHistoryNewProps = {
  form: any;
  isDisabled?: boolean;
};

const PersonalHistoryNew: FC<PersonalHistoryNewProps> = ({
  form,
  isDisabled,
}) => {
  //   useEffect(() => {
  //     if (!form.getFieldValue("habitsAddictions")) {
  //       form.setFieldValue("habitsAddictions", "no");
  //     }

  //     if (!form.getFieldValue("knownAllergies")) {
  //       form.setFieldValue("knownAllergies", "no");
  //     }
  //   }, [form]);

  useEffect(() => {
    setTimeout(() => {
      if (!form.getFieldValue("habitsAddictions")) {
        form.setFieldValue("habitsAddictions", false);
      }
      if (!form.getFieldValue("knownAllergies")) {
        form.setFieldValue("knownAllergies", false);
      }

    }, 0);
  }, [form]);

  return (
    <>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "18px",
          marginBottom: "6px",
          fontWeight: "bold",
        }}
      >
        Personal History
      </div>

      <Form
        form={form}
        layout="vertical"
        labelAlign="left"
        labelWrap
        style={{ width: "100%", padding: "8px" }}
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="Known Allergies"
              name="knownAllergies"
              rules={[{ required: true, message: "Please select an option" }]}
            >
             <Radio.Group
                options={[
                  { label: "yes", value: true },
                  { label: "no", value: false },
                ]}
                disabled={isDisabled}
              ></Radio.Group>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={6} xl={6}>
            <Form.Item
              label="Habits Addictions"
              name="habitsAddictions"
              rules={[{ required: true, message: "Please select an option" }]}
            >
              <Radio.Group
                options={[
                  { label: "yes", value: true },
                  { label: "no", value: false },
                ]}
                disabled={isDisabled}
              ></Radio.Group>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default PersonalHistoryNew;
